import React from "react";
import useConfig from "../../../../../hooks/use-config";
import { SystemMessages } from "../systemMessages";
import { isSender } from "../../../../../utils/chat.utils";
const ICON_BASE_URL = 'https://opensooqui2.os-cdn.com/api/apiV/android/xxh';
const RichText = (props) => {
    var _a, _b, _c;
    const { message } = props;
    const config = useConfig();
    const lang = config.lang;
    const messageType = `${message.type}.${message.subType}`;
    message.text = SystemMessages[messageType].text(lang, message.sender_name, isSender(message));
    return (React.createElement("div", { className: 'rich-text__container' },
        React.createElement("div", { className: 'rich-text__icon-box' },
            React.createElement("img", { src: `${ICON_BASE_URL}${message.rich.icon}` })),
        React.createElement("div", { className: 'rich-text__text', style: { color: (_b = (_a = message.rich) === null || _a === void 0 ? void 0 : _a.fColor) !== null && _b !== void 0 ? _b : "#000000" } }, (_c = message.text) !== null && _c !== void 0 ? _c : "")));
};
export default RichText;
